import {ProFenzMark} from './Wordmark';
import type {TenantBrand} from './tenantBranding';
import './TenantIdentity.css';

export function TenantIdentity({brand,context}:{brand:TenantBrand|null;context:'desktop-header'|'login-card'}) {
  const mark=<ProFenzMark context={context}/>;
  if(!brand)return mark;
  return <div className="tenant-identity">{mark}<p className="tenant-identity-name">{brand.displayName}</p></div>;
}
